export default {
      id: "alert-icon-info-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#alert-icon-info",
      toString: function () {
        return this.url;
      }
    }